<ng-template #content_device_template_map let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.printer">
        <div class="side_popup_header">
            <span>{{localService.languageContent.printer.printerDeviceMap}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="height: calc(100vh - 120px);">
            <div class="row side_popup_body_row">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.printer.title" [IsMandatory]="true" />
                    <input autocomplete="off" type="text" [(ngModel)]="title"
                        title="{{localService.languageContent.printer.title}}"
                        placeholder="{{localService.languageContent.printer.title}}" />
                </div>
            </div>
            <div class="row side_popup_body_row" *ngIf="loadedApi">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.printer.deviceName" [IsMandatory]="true" />
                    <ngx-select [isFocused]="true" [placeholder]="localService.languageContent.printer.selectDeviceName"
                        [(ngModel)]="selectedKey" [noAutoComplete]="true" [items]="itemSourceDeviceNames"
                        [optionValueField]="'key'" [optionTextField]="'value'">
                    </ngx-select>
                </div>
            </div>
            <div class="row side_popup_body_row" *ngIf="loadedApi">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.printer.printerTemplateMaps" [IsMandatory]="true" />
                    <div class="banner">
                        <div class="row styled_row" *ngFor="let item of itemSourceTemplates">
                            <div class="col-12">
                                <label style="margin-left:20px;font-weight:normal;" title="{{item.value}}">
                                    <input type="checkbox" [(ngModel)]="item.isSelected">
                                    <span style="color:darkslategrey">&nbsp;{{item.value}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-6" style="text-align: left;">
                    <span *ngIf="message != ''"
                        [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
                </div>
                <div class="col-6" style="text-align: right;">
                    <button class="btn btn-primary" (click)="onAction(1)">
                        <i class="material-icons" style="color: white;top: 5px;position: relative;">{{itemId ? 'save' :
                            'add'}}</i>
                        <span>{{itemId ? localService.languageContent.common.update :
                            localService.languageContent.common.add}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>